import { useMyInfoStore } from "../../../lib/store/useMyInfoStore";
import Button from "../../atoms/button";
import { getZodiacImg } from "../../../lib/utils/birthdayUtils";
import { vw } from "../../../lib/utils/responsiveUtils";

interface WarningScreenProps {
  next: () => void;
}
export default function WarningScreen({ next }: WarningScreenProps) {
  const { myInfo } = useMyInfoStore();

  const zodiacImg = getZodiacImg(myInfo.birthdate);

  return (
    <div className="flex flex-col justify-between min-h-[calc(100vh-56px)] pb-[35px]">
      <div className="flex flex-col justify-center items-center text-center flex-1">
        <div
          className="rounded-full bg-[#f5f5f5]"
          style={{ width: vw(132), height: vw(132) }}
        >
          <img src={zodiacImg} alt="띠 이미지" />
        </div>
        <p className="font-bold pt-[13px] pb-[24px] text-4xl">
          {myInfo.name} 님 회원을
          <br />
          탈퇴하시겠습니까?
        </p>
        <span className="text-[#888] font-[500]">
          회원탈퇴 시, 정보는 삭제되며
          <br />
          복구되지 않습니다.
        </span>
      </div>
      <div className="space-y-[10px] pb-[]">
        <Button
          onClick={next}
          className="w-full font-bold"
          variant={"primary"}
          label="보이스파크 탈퇴하기"
        />
      </div>
    </div>
  );
}
